// extracted by mini-css-extract-plugin
export var dot = "_qd-2";
export var wave = "_qd-0";
export var waveSmall = "_qd-1";